
export type ColorSelectProp = {
  colorSetList: ColorSet[];
  onClick: (color: string) => void;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  value: string;
};
export type ColorSet = {
  colorName: string;
  className: String;
  hex: string;
};

const style = {
  size: {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12',
  }
}

export const ColorSelect = (
  {colorSetList, onClick, size = 'md', value}: ColorSelectProp
) => {
  return (<div className={"flex space-x-2"}>
  {colorSetList.map((color: ColorSet, index: number) => {
    return (
      <div key={`${color.colorName}-${index}`} className={`border ${value === color.colorName ? 'border-indigo-500' : 'border-gray-100'} rounded-full border-2`}>
        <div
          className={`${color.className} ${style.size[size]} border border-white border-2 rounded-full text-center cursor-pointer`}
          title={`${color.colorName}`}
          onClick={() => onClick(color.colorName)}
        ></div>
      </div>
    );
  })}
  </div>);
}